import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';


import {EstudioService} from '../estudio.service';


@Injectable({
  providedIn: 'root'
})
export class PeriodosResolver  {

    constructor(private router: Router, private estudioService: EstudioService) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)/*: Observable<HttpResponse<any>>*/ {
        return this.estudioService.getPeriodos(true)/*.map(periodo => {
            return periodo;
        })*/;
    }
}
